import { useContextState } from '@/hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    accordion: {
      width: '100%',
      boxShadow: `0px 2px 3px 1px rgba(0,0,0,0.40)`,
      borderRadius: '6px',
      border: 'none',
      overflow: 'hidden',
      '&:before': { display: 'none' },
    },
    accordionSummary: {
      padding: '0 16px',
      '& .MuiAccordionSummary-expandIconWrapper svg': {
        fontSize: '2rem',
      },
    },
    accordionDetails: {
      borderTop: `1px solid ${colors.color27}`,
      backgroundColor: colors.color14,
      padding: '10px 10px',
    },
    questionText: {
      fontSize: '16px',
      fontWeight: '500',
      color: colors.color22,
      wordBreak: 'break-word',
    },
    answerText: {
      fontSize: '15px',
      color: colors.color22,
      marginTop: '2px',
    },
    noData: {
      fontSize: '14px',
      color: 'c_grey.main',
      textAlign: 'center',
    },
    downloadButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    expandAllButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    downloadAllButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
  }
}

export { useStyles }
